module.exports = __webpack_public_path__ + "img/basketball.61753d35.svg";